import React, {Component} from 'react'
import { connect } from 'react-redux'
import {saveAddresses, UserService, AddressesService, saveUser, buildTransaction } from '../normalizer'

import { isEmpty } from '../../../utils/utils';
import { prefix } from '../../../i18n';
import { ToastService } from '../../Gamification2026Template/shared/Toast';

const tUser = prefix('user')
class CampaignUserContainer extends Component {
  state = {
    editingUserGeneralData : false,
    isAdding: false,
    editPassword: false,
    gender: {id: null},
    errors: {},
    // Incremented after each successful profile save so that UserInfoEdit
    // (which uses uncontrolled defaultValue inputs) always remounts with the
    // latest Redux data rather than showing the previous session's values.
    saveVersion: 0,
  }
  getAddresses(){
    this.props.startTransaction(() =>
      AddressesService.getAddresses().then((response) => {
        const addresses = response.data
        this.props.saveAddresses(addresses);
      })
    )
  }

  handleEditUserGeneralData = () => {
    this.setState({editingUserGeneralData: true})
  }

  handleEditCancel = () => {
    ToastService.warning('Alterações não guardadas.')
    this.setState({editingUserGeneralData: false})
  }

  handleEditUserPassword = () => {
    this.setState({ editPassword: true })
  }

  handleEditPasswordCancel = (warn = true) => {
    warn && ToastService.warning('Alterações não guardadas.')
    this.setState({ editPassword: false })
  }

  handleSubmitPassword = (payload, success, failure) => {
    this.props.startTransaction( () =>
      UserService.updatePassword(payload)
      .then(response =>{
        success && success()
      }).catch((error) => {
        failure && failure(error.response.data)
      }).finally(()=>{
        this.setState({ editPassword: false })
      }));
  }

  handleNewAddress = () => {
    this.setState({isAdding: true})
  }
  
  handleNewAddressCancel = () => {
    ToastService.warning('Alterações não guardadas.')
    this.setState({isAdding: false})
  }

  handleNewAddressCreation = (formData) => {
    if (isEmpty(formData) ){
      return;
    }

    const payload = {
      address: {
        ...formData,
        zip_code: formData.zipCode,
        main_name: formData.addressName,
        first_name: formData.firstName,
        last_name: formData.lastName,
        state_id: this.props.selectedState.id,
        country_id: this.props.selectedCountry.id
      }
    }
  
    return this.props.startTransaction(() =>
      AddressesService.createAddress(payload)
        .then((response) => {
          this.props.saveAddresses(response.data);
          ToastService.success('Endereço adicionado com sucesso.')
          this.setState({isAdding: false, error: {}})
          // Guard: callBack is optional; calling it unconditionally throws when
          // the form payload doesn't include one, which triggers the catch handler
          // and shows a spurious error toast immediately after the success toast.
          if (typeof formData.callBack === 'function') {
            formData.callBack()
          }
        })
        .catch((error) => {
          ToastService.error('Ocorreu um erro com a adição do endereço.')
          this.setState({errors: error.response.data, isAdding: true});
        })
    )
  }

  onChangeGender = (e) => {
    this.setState({gender: e})
  }

  handleChangeAvatar = (file) => {
    if(!file) {
      ToastService.error(tUser('unknown-format'));
      return
    }

    const formData = new FormData();
    
    formData.append('user[avatar]', file, file.name );
    this.props.startTransaction(()=>
      UserService.updateAvatar(formData).then((response) => {
        localStorage.setItem('user', JSON.stringify(response.data.user));
        this.props.saveUser(response.data.user);
        ToastService.success('Avatar modificado com sucesso.');
      })
      .catch((error) => {
        ToastService.error(tUser('image-error'));
      })
    )
  }

  handleSubmitUserEdit = (formData) => {

    const {gender} = this.state;
    let payload = {user: {...formData}}
    payload.user.gender  = gender.id

    if (isEmpty(payload.user)){
      return;
    }
    this.props.startTransaction(()=>
      UserService.updateUser(payload)
        .then((response) => {
          localStorage.setItem('user', JSON.stringify(response.data.user));
          this.props.saveUser(response.data.user);
          ToastService.success('Utilizador atualizado com sucesso.')
          this.setState(prev => ({
            editingUserGeneralData: false,
            saveVersion: prev.saveVersion + 1,
          }))
        })
        .catch((error) => {
          ToastService.error('Ocorreu um erro com a atualização do utilizador.')
        })
    )
  }

  componentDidMount() {
    if(this.props.addresses.length === 0){
      this.getAddresses()
    }
    if (this.state.gender.id !== this.props.user.gender){
      this.setState({gender: {id: this.props.user.gender}})
    }
  }

  componentDidUpdate(prevProps) {
    // Re-sync local gender state whenever the Redux user record changes
    // (e.g. after a successful save the API may return a canonical gender
    // value that differs from what the dropdown set in local state).
    if (prevProps.user !== this.props.user) {
      this.setState({ gender: { id: this.props.user.gender } })
    }
  }

  render() {
    const {component: Component, ...rest} = this.props
    return (
      <>
      <Component {...rest}
          {...this.state}
        gender = {this.state.gender || this.props.user.gender}
        onEditGeneralData={this.handleEditUserGeneralData}
        onEditCancel={this.handleEditCancel}
        onEditSubmit={this.handleSubmitUserEdit}
        onNewAddressEnable={this.handleNewAddress}
        onNewAddressCreation={this.handleNewAddressCreation}
        onNewAddressCancel={this.handleNewAddressCancel}
        onEditPassword={this.handleEditUserPassword}
        onEditPasswordCancel={this.handleEditPasswordCancel}
        onEditPasswordSubmit={this.handleSubmitPassword}
        onChangeGender={this.onChangeGender}
        onAvatarChange={this.handleChangeAvatar}
      />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  campaignUser: state.balanceReducer.campaignUser,
  user: state.userReducer.user,
  addresses: state.addressesReducer.addresses,
  client: state.userReducer.client,
  consents: state.userReducer.consents
})

const mapDispatchToProps = (dispatch) => ({
  startTransaction: buildTransaction(dispatch),
  saveAddresses: (addresses) => {
    dispatch(saveAddresses(addresses))
  },
  saveUser: (user) => {
    dispatch(saveUser(user));
  }
})

const Container = connect(mapStateToProps, mapDispatchToProps)(CampaignUserContainer)

export function withCampaignUserContainer(component) {
  return (props) => (
    <Container
      component={component}
      {...props}
    />
  )
}

export default Container
